/** Namespace `calendar` — wird befüllt während der Komponenten-Migration. */
export const calendar = {
  de: {
    calendar: {
      prevPeriod: 'Vorheriger Zeitraum',
      nextPeriod: 'Nächster Zeitraum',
      monthShort: 'M',
      weekShort: 'W',
      dayShort: 'T',
      noTitle: '(ohne Titel)',
      loadError: 'Termine konnten nicht geladen werden',
      syncSuccess: 'Google Calendar erfolgreich synchronisiert!',
      syncError: 'Synchronisation mit Google Calendar fehlgeschlagen',
      enterValidEmail: 'Bitte eine gültige E-Mail-Adresse eingeben',
      shareSuccess:
        'Kalender erfolgreich mit {{email}} geteilt! Die Events sind nun im eigenen Google Kalender sichtbar.',
      shareFailed: 'Freigabe fehlgeschlagen: {{error}}',
      shareAlreadyHasAccess: 'Benutzer {{email}} hat bereits Zugriff auf den Kalender.',
      shareError: 'Freigabe-Fehler: {{error}}',
      debugComplete:
        'Debug abgeschlossen! {{count}} Events gefunden. Details in der Browser-Konsole.',
      debugFailed: 'Debug fehlgeschlagen: {{error}}',
      debugError: 'Debug-Fehler: {{error}}',
      syncTitle: 'Google Kalender synchronisieren',
      syncing: 'Sync…',
      sync: 'Sync',
      debugTitle: 'Google Events debuggen',
      debugging: 'Debug…',
      debug: 'Debug',
      shareTitle: 'Kalender freigeben',
      share: 'Freigeben',
      sharing: 'Freigeben…',
      eyebrow: 'Übersicht',
      description: 'Termine planen, Google Kalender synchronisieren',
      newAppointment: 'Neuer Termin',
      shareFormTitle: 'Google Kalender freigeben',
      shareFormText:
        'Service-Account-Kalender mit deinem Google-Konto teilen, um Events direkt in Google Kalender zu sehen.',
      shareEmailPlaceholder: 'Deine Google-E-Mail-Adresse',
      legendTitle: 'Statusübersicht',
      legendPendingWebsite: 'Offen (Website)',
      legendScheduled: 'Geplant',
      legendConfirmed: 'Bestätigt',
      legendCompleted: 'Abgeschlossen',
      legendCancelled: 'Storniert',
      legendNoShow: 'Nicht erschienen',
      legendWebsiteBorder: 'Gestrichelter Rand = Buchung über seadent.es',
      legendGoogleOnly: 'Grau gepunktet = Event nur in Google Calendar',
      legendExtraCalendar: 'Lila gepunktet = Zusatzkalender (nur Anzeige)',
    },
  },
  es: {
    calendar: {
      prevPeriod: 'Período anterior',
      nextPeriod: 'Período siguiente',
      monthShort: 'M',
      weekShort: 'S',
      dayShort: 'D',
      noTitle: '(sin título)',
      loadError: 'No se pudieron cargar las citas',
      syncSuccess: '¡Google Calendar sincronizado correctamente!',
      syncError: 'Error al sincronizar con Google Calendar',
      enterValidEmail: 'Por favor, introduzca una dirección de correo electrónico válida',
      shareSuccess:
        '¡Calendario compartido correctamente con {{email}}! Los eventos ya son visibles en su propio Google Calendar.',
      shareFailed: 'Error al compartir: {{error}}',
      shareAlreadyHasAccess: 'El usuario {{email}} ya tiene acceso al calendario.',
      shareError: 'Error al compartir: {{error}}',
      debugComplete:
        '¡Depuración completada! Se encontraron {{count}} eventos. Detalles en la consola del navegador.',
      debugFailed: 'Error de depuración: {{error}}',
      debugError: 'Error de depuración: {{error}}',
      syncTitle: 'Sincronizar Google Calendar',
      syncing: 'Sinc…',
      sync: 'Sinc',
      debugTitle: 'Depurar eventos de Google',
      debugging: 'Depurar…',
      debug: 'Depurar',
      shareTitle: 'Compartir calendario',
      share: 'Compartir',
      sharing: 'Compartiendo…',
      eyebrow: 'Resumen',
      description: 'Planificar citas, sincronizar Google Calendar',
      newAppointment: 'Nueva cita',
      shareFormTitle: 'Compartir Google Calendar',
      shareFormText:
        'Comparta el calendario de la cuenta de servicio con su cuenta de Google para ver los eventos directamente en Google Calendar.',
      shareEmailPlaceholder: 'Su dirección de correo de Google',
      legendTitle: 'Resumen de estados',
      legendPendingWebsite: 'Pendiente (sitio web)',
      legendScheduled: 'Programada',
      legendConfirmed: 'Confirmada',
      legendCompleted: 'Completada',
      legendCancelled: 'Cancelada',
      legendNoShow: 'No asistió',
      legendWebsiteBorder: 'Borde discontinuo = reserva a través de seadent.es',
      legendGoogleOnly: 'Punteado gris = evento solo en Google Calendar',
      legendExtraCalendar: 'Punteado lila = calendario adicional (solo lectura)',
    },
  },
};
